/*
  Mobile sticky buy bar: slides up once the hero section has scrolled out of
  view, hides again when the hero returns. Visibility below 750px is handled
  in CSS; this only toggles the scrolled state.
*/
(function () {
  if (window.__nuvaStickyCta) return;
  window.__nuvaStickyCta = true;

  function init() {
    var bar = document.querySelector('.nuva-sticky-cta');
    if (!bar) return;
    var hero = document.querySelector('.nuva-hero');
    if (!hero || !('IntersectionObserver' in window)) {
      bar.classList.add('is-visible');
      return;
    }
    new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { threshold: 0 }).observe(hero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
